/** @jsx jsx */

import { capitalize } from 'lodash';

import { jsx, css } from '@emotion/core';

import { STATUSES, Status, Step } from './PublishingSteps';

const Styles = {
  title: css`
    padding-bottom: 20px;
    font-size: 18px;
    line-height: 1.5em;
    font-weight: 600;
    color: 'neutral700';
  `,
};

type Props = {
  currentStatus: Status;
  integrationId: number;
  integrationName: string;
  step: Step;
};

export default function GettingReady({
  currentStatus,
  integrationId,
  integrationName,
  step,
}: Props) {
  const { label, TodosComponent } = step;

  const title =
    currentStatus === 'beta'
      ? 'Hit these milestones to get the most from your Zapier partnership'
      : `Getting Ready for ${capitalize(
          label.toLowerCase() === STATUSES.public ? 'partnership' : label
        )}`;

  return (
    <div>
      <h3 css={Styles.title}>{title}</h3>
      {TodosComponent && (
        <TodosComponent
          integrationId={integrationId}
          integrationName={integrationName}
        />
      )}
    </div>
  );
}
